// extracted by mini-css-extract-plugin
export default {"whatsapp_float":"WhatsAppButton_whatsapp_float__C8Xiu","whatsapp_icon":"WhatsAppButton_whatsapp_icon__B3bRn"};